/**
 * LiveStatsPanel.tsx
 *
 * Real-time statistics display showing trades, win rate, and running P&L.
 */

import React from 'react';

interface LiveStatsPanelProps {
  tradesCount: number;
  winsCount: number;
  winRate: number;
  pnlRunning: number;
}

const LiveStatsPanel: React.FC<LiveStatsPanelProps> = ({
  tradesCount,
  winsCount,
  winRate,
  pnlRunning
}) => {
  const pnlTone = pnlRunning >= 0 ? 'is-gain' : 'is-loss';
  const pnlPrefix = pnlRunning >= 0 ? '+' : '';
  const formattedPnl = `${pnlPrefix}$${Math.abs(pnlRunning).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })}`;

  return (
    <div className="bt-panel">
      {/* Header */}
      <div className="bt-panel-h">
        <span className="bt-h">Live Statistics</span>
      </div>

      {/* Stats */}
      <div className="bt-stats">
        {/* Total Trades */}
        <div className="bt-stat">
          <span className="bt-stat-l">Total Trades</span>
          <span className="bt-stat-v n">{tradesCount}</span>
        </div>

        {/* Win Rate */}
        <div className="bt-stat">
          <span className="bt-stat-l">
            Win Rate
            <small className="n">({winsCount}/{tradesCount})</small>
          </span>
          <span className={`bt-stat-v n ${tradesCount > 0 ? 'is-t1' : 'is-t3'}`}>
            {tradesCount > 0 ? `${winRate.toFixed(0)}%` : '--%'}
          </span>
        </div>

        {/* Running P&L */}
        <div className="bt-stat">
          <span className="bt-stat-l">Running P&L</span>
          <span className={`bt-stat-v n ${pnlTone}`}>{formattedPnl}</span>
        </div>
      </div>
    </div>
  );
};

export default LiveStatsPanel;
